export const ACTION_PREFIX = 'ACCOUNT_INTENT_SUMMARY';
export const PARTITION = 'AccountIntentSummary';

export const actionTypes = {
  GET_ACCOUNT_INTENT_FULLFILLED: 'GET_ACCOUNT_INTENT_FULLFILLED',
  GET_ACCOUNT_INTENT_PENDING: 'GET_ACCOUNT_INTENT_PENDING',
  GET_ACCOUNT_INTENT_REJECTED: 'GET_ACCOUNT_INTENT_REJECTED',
};
